import React, { Component } from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { Input, message, PageHeader, Switch, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";

class DemoCountryStates extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    loading: false,
    searchText: "",
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
  };
  getCountry = () => {
    this.setState({
      loading: true,
    });
    professionalAction.getCountry().then((res) => {
      this.setState({
        data: res.pc_countrystates,
        loading: false,
      });
    });
  };

  updateCountry = (id, is_active) => {
    const temp = {
      id: id,
      is_active: is_active,
    };
    professionalAction
      .updateCountry(temp)
      .then(() => {
        message.success("Updated Successfully");
        this.setState((prevState) => ({
          data: prevState.data.map((item) =>
            item.id === id ? { ...item, is_active } : item,
          ),
        }));
      })
      .catch(() => {
        message.error("Update failed");
      });
  };

  handleStatusToggle = (record, checked) => {
    this.updateCountry(record.id, checked);
  };

  handleSearchChange = (e) => {
    this.setState((prevState) => ({
      searchText: e.target.value,
      pagination: {
        ...prevState.pagination,
        current: 1,
      },
    }));
  };

  handleTableChange = (pagination) => {
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        ...pagination,
      },
    }));
  };

  getFilteredData = () => {
    const { data, searchText } = this.state;
    const query = searchText.trim().toLowerCase();

    if (!query) {
      return data;
    }

    return data.filter((item) => {
      const stateName = (item.state || "").toLowerCase();
      const statusText = item.is_active ? "active" : "inactive";
      return stateName.includes(query) || statusText.includes(query);
    });
  };

  componentDidMount = () => {
    this.getCountry();
  };

  render() {
    const { loading, searchText, pagination } = this.state;
    const { t } = this.context;
    const filteredData = this.getFilteredData();
    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: "State Name",
        dataIndex: "state",
        key: "state",
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        render: (is_active) => (is_active ? "Active" : "Inactive"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (text, record) => (
          <Switch
            checked={!!record.is_active}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            onChange={(checked) => this.handleStatusToggle(record, checked)}
          />
        ),
      },
    ];
    return (
      <>
        <PageHeader>States</PageHeader>
        <div
          style={{
            marginBottom: 16,
            maxWidth: 320,
          }}
        >
          <Input
            allowClear
            placeholder="Search state or status..."
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            value={searchText}
            onChange={this.handleSearchChange}
          />
        </div>
        <Table
          bordered
          loading={loading}
          scroll={{ x: "max-content" }}
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          rowClassName={() => "govt-table-row"}
          pagination={{
            ...pagination,
            total: filteredData.length,
            showTotal: (total) => `Total ${total} states`,
          }}
          onChange={this.handleTableChange}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedCountryStates = connect(mapStateToProps)(DemoCountryStates);
export { connectedCountryStates as CountryStates };
